import AbstractChatMessage from './AbstractChatMessage'
import cloneDeep from 'lodash/cloneDeep'
import { MessageTypes } from '@/constants/chat/MessageTypes'

export default class FileChatMessage extends AbstractChatMessage {
  declare body: {
    name: string
    url: string | null
    size: number // in bytes
  }

  constructor({ body, ...data }: LX.FileChatMessage) {
    super(data)
    Object.assign(
      this,
      cloneDeep({
        body: {
          name: body.description || body.name,
          url: body.url,
          size: Number(body.size),
        },
      })
    )
  }

  static fromServer(data: LX.FileChatMessage) {
    return new FileChatMessage(data)
  }

  getShortMessage() {
    return `File: ${this.body.name}`
  }
}
